import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";
import {
  setStepStatus,
  setRejectedFields,
} from "../../../Redux/store/onboardingFormSlice";
import LabelWithStatus from "../../../Components/onboarding/label-with-status";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";

const CashAccount = ({ setCurrentStep, applicationType }) => {
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const individualAccountType = useSelector(
    (state) => state.form.individualAccountType,
  );
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const userStatus = useSelector((state) => state.user.userStatus);
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [accountCount, setAccountCount] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [existingAccounts, setExistingAccounts] = useState([]);

  const [accounts, setAccounts] = useState([]);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const isIndividual = applicationType === 1 && individualAccountType == 5;
  const stepIndex = isIndividual ? 4 : 3;

  const currentStatus = stepStatus?.[stepIndex]?.status ?? null;

  const LOCKED_STATUSES = ["IN_REVIEW", "COMPLETED", "APPROVED"];

  const isLocked = LOCKED_STATUSES.includes(currentStatus);
  const isEditable = Boolean(currentStatus) && !isLocked;

  const isInReview = ["IN_REVIEW", "COMPLETED"].includes(currentStatus);
  const isApproved = currentStatus === "APPROVED";
  const handleAccountChange = (index, value) => {
    const newAccounts = [...accounts];

    // Prevent selecting the same currency twice
    if (newAccounts.includes(value) && newAccounts[index] !== value) {
      showToast("This currency has already been selected.", "error");
      return;
    }

    newAccounts[index] = value;
    setAccounts(newAccounts);
  };
  // Add new account
  const increaseCount = () => {
    if (accountCount < currencies.length) {
      const unusedCurrency = currencies.find(
        (c) => !accounts.some((acc) => acc.value === c.value),
      );
      setAccounts([...accounts, unusedCurrency || currencies[0]]);
      setAccountCount(accountCount + 1);
    }
  };

  // Remove last account
  const decreaseCount = () => {
    if (accountCount > 1) {
      setAccounts(accounts.slice(0, -1));
      setAccountCount(accountCount - 1);
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  // Filter options to prevent duplicates
  const getFilteredOptions = (currentIndex) =>
    currencies.filter(
      (c) =>
        !accounts.some((acc, i) => acc.value === c.value && i !== currentIndex),
    );
  const handleContinue = (isFinal) => {
    setLoading(true);
    handlesave(isFinal);
  };

  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      applicationType == 1
        ? `${BASE_URL}/v1/onboarding/cash-account/reset`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/cash-account/reset`
          : `${BASE_URL}/v1/onboarding/trust/cash-account/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetails();
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    if (applicationType == 1 && individualAccountType == 5) {
      setCurrentStep(4);
    } else {
      setCurrentStep(3);
    }
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;

    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/cash-account/submit`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/cash-account/submit`
          : `${BASE_URL}/v1/onboarding/trust/cash-account/submit`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/cash-account/update`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/cash-account/update`
          : `${BASE_URL}/v1/onboarding/trust/cash-account/update`;
    let bodyData = {
      currencies: accounts.map((acc) => acc?.value),
      is_submitted: isFinal,
    };

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? "POST" : "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          if (applicationType == 1 && individualAccountType == 5) {
            setCurrentStep(6);
          } else {
            setCurrentStep(5);
          }
          toastMessage = {
            message: response.message,
            type: "success",
          };
          const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
    dispatch(updateFormData({ field: "userAccounts", value: accounts }));
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        applicationType == 1
          ? `/v1/onboarding/cash-account/verification/list`
          : applicationType == 2
            ? `/v1/onboarding/corporate/cash-account/verification/list`
            : `/v1/onboarding/trust/cash-account/verification/list`,
      );

      if (response.status == 200) {
        if (response.data) {
          setExistingAccounts(response.data);
        } else {
          setExistingAccounts([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (currencies?.length > 0) {
      // Set first currency as default selected account
      setAccounts([currencies[0]]);
    }
  }, [currencies]);
  useEffect(() => {
    if (existingAccounts?.length > 0) {
      const preselected = existingAccounts.map((acc) => ({
        value: acc.currency.value.id,
        label: `${acc.currency.value.name}`,
        verification_id: acc.currency.verification_id,
        status: acc.currency.status,
        rejection_reason: acc.currency.rejection_reason,
        rejection_comment: acc.currency.rejection_comment,
        rejection_timestamp: acc.currency.rejection_timestamp,
        rejected_by: acc.currency.rejected_by,
        comments: acc.currency.comments,
      }));
      setAccounts(preselected);
      setAccountCount(preselected.length);
    } else if (currencies?.length > 0) {
      // fallback: select first currency by default
      setAccounts([currencies[0]]);
      setAccountCount(1);
    }
  }, [currencies, existingAccounts]);
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(
        applicationType == 1
          ? `/v1/onboarding/cash-account/currencies`
          : applicationType == 2
            ? `/v1/onboarding/corporate/cash-account/currencies`
            : `/v1/onboarding/trust/cash-account/currencies`,
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,

            verification_id: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        });

        setCurrencies(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCurrencies([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getAllCurrency();
  }, []);
  useEffect(() => {
    if (!stepStatus?.length) return;
    const isIndividual = applicationType === 1;
    const stepIndex = isIndividual ? 4 : 3;
    const step = stepStatus[stepIndex];

    if (step?.status !== "DRAFT") {
      getDetails();
    }
  }, [applicationType, stepStatus]);
  useEffect(() => {
    if (!stepStatus?.length) return;
    const isIndividual = applicationType === 1;
    const stepIndex = isIndividual ? 4 : 3;
    const step = stepStatus[stepIndex];
    if (updateFieldStatus && step?.status !== "DRAFT") {
      getDetails();
    }
  }, [applicationType, updateFieldStatus, stepStatus]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {isInReview && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              This section is <strong>in review by our onboarding team</strong>.
              You will be notified once the verification is complete.{" "}
            </span>
          </div>
        )}
        {isApproved && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}

        {accounts.length > 0 &&
          rejectedFields?.CASH_ACCOUNTS?.rejected_fields?.length > 0 && (
            <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="font-semibold text-red-700 mb-1">
                {rejectedFields.CASH_ACCOUNTS.rejected_fields.length === 1
                  ? "The following field requires correction:"
                  : "The following fields require correction:"}{" "}
              </p>

              <div className="flex flex-wrap gap-2">
                {accounts
                  .filter((account) => account.status == "rejected")
                  .map((field) => (
                    <span
                      key={field.value}
                      className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                    >
                      {field.label}
                    </span>
                  ))}
              </div>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/money-2.svg" alt="Money Icon" className="h-6 w-6" />
              <h1 className="text-xl font-medium">Cash Account Information</h1>
            </div>
            <ul className="ml-2 text-xs font-medium">
              <li>
                Every Cash Account has a seeding amount of $10,000 and a monthly
                maintenance fee associated with it.
              </li>
              <li className="text-[#FF5050]">
                If you need to adjust any information from the previous section,
                please click on the “Reset Application” button
              </li>
            </ul>
          </div>

          <div className="px-4 mt-4 flex items-center space-x-0 text-black font-medium ">
            <span className="text-sm mr-4">No. Of Cash Account</span>
            <button
              onClick={decreaseCount}
              className="border-2 border-gray-300 px-3 py-1  rounded-tl-xl rounded-bl-xl hover:bg-gray-200"
            >
              −
            </button>
            <span className="px-4 py-1  border-t-2 border-b-2 border-gray-300">
              {accountCount}
            </span>
            <button
              onClick={increaseCount}
              className="px-3 py-1  hover:bg-gray-200  border-2 border-gray-300 rounded-tr-xl rounded-br-xl"
            >
              +
            </button>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: accountCount }).map((_, index) => (
              <div key={index} className="px-4 py-2">
                <LabelWithStatus
                  id={"cashAccount" + index + 1}
                  label={`Account ${String(index + 1).padStart(2, "0")}`}
                  required={true}
                  fieldData={accounts[index]}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  options={getFilteredOptions(index)} // ✅ dynamically filtered options
                  preselectedValue={accounts[index] || currencies[0]} // fallback to first currency
                  onSelect={(value) => handleAccountChange(index, value)}
                  parentClass={
                    accounts[index] && accounts[index].status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {isEditable && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
              <ConfirmResetButton
                onConfirm={handleReset}
                isReset={true}
                isBack={true}
                onBack={handleBack}
              />
            </div>

            <div className="flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              <div className="relative w-full md:w-auto flex justify-center md:justify-end">
                <button
                  onClick={() => {
                    handleContinue(false);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Save as Draft</span>
                </button>
              </div>
              <ConfirmContinueButton
                onContinue={() => handleContinue(true)}
                buttonText="Continue"
                confirmTitle="Save Section"
                confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
              />
            </div>
          </>
        )}
        {isLocked && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
              <ConfirmResetButton
                onConfirm={handleReset}
                isReset={false}
                isBack={true}
                onBack={handleBack}
              />
            </div>
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              {/* Save as Draft */}
              <button
                onClick={() => {
                  if (applicationType == 1 && individualAccountType == 5) {
                    setCurrentStep(6);
                  } else {
                    setCurrentStep(5);
                  }
                }}
                className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Next</span>
              </button>
            </div>
          </>
        )}
      </footer>
    </div>
  );
};

export default CashAccount;
